import {
  ROLE_PROOF_READER,
  ROLE_SYSTEM_ADMIN,
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  ROLE_LSP,
} from '@/utils/const.js';
import store from '@/store';

export default [
  {
    path: '/reset-password',
    name: 'reset_password',
    component: () => import('@/views/reset_password/index.vue'),
    meta: {
      title: 'Reset password',
      middleware: {
        access: 'guest',
      },
    },
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('@/views/auth/index.vue'),
    meta: {
      title: 'Authorization',
      middleware: {
        access: 'guest',
      },
    },
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/views/registration/index.vue'),
    meta: {
      title: 'Registration',
      middleware: {
        access: 'guest',
      },
    },
  },
  {
    path: '/approve/:info?',
    name: 'emailApproving',
    component: () => import('@/views/auth/emailApproving/index.vue'),
    meta: {
      title: 'Email confirmation',
      middleware: {
        access: 'guest',
      },
    },
    beforeEnter: (to, from, next) => {
      return store.getters.isAuthenticated === true ? next('/') : next();
    },
  },
  {
    path: '/restore/:info?',
    name: 'restore',
    component: () => import('@/views/auth/restore/index.vue'),
    meta: {
      title: 'Restore password',
      middleware: {
        access: 'guest',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
  {
    path: '/manage/changepassword',
    name: 'change_password',
    component: () => import('@/views/manage/changepassword/index.vue'),
    meta: {
      title: 'Change password',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
];
